// Configurazione Feature Flags
const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const isExplicitlyDisabled = urlParams && urlParams.get('WORLD_3D_ENABLED') === 'false';

export const FEATURES = {
    // Abilitato ufficialmente in produzione per l'ingresso 3D dalla mappa
    WORLD_3D_ENABLED: !isExplicitlyDisabled
};
